import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledQuickFilterComponentDiv = styled.div`
  ${rtl`
  @media only ${theme.mediaQuery.allTablets} {
    margin: 0 !important;
  }
  @media only ${theme.mediaQuery.allMobiles} {
    padding: 0;
  }
  .quick-filter-container {
    .quick-filter-option-button:focus {
      outline: 0px solid -webkit-focus-ring-color;
    }
    .quick-filter-option-button {
      box-sizing: border-box;
      height: ${toRem(38)};
      border: ${toRem(1)} solid ${theme.color['close-silver']};
      border-radius: ${toRem(19)};
      background-color: ${theme.color['white']};
      padding: ${toRem(8)} ${toRem(12)};
      margin: 0 ${toRem(8)} 0 0;
      min-width: ${toRem(80)};
      font-weight: ${theme.fonts['fontWeightRegular']};

      @media only ${theme.mediaQuery.allMobiles} {
        margin-right: ${toRem(4)};
      }

      &.checked {
        background-color: ${theme.color['close-silver']};
        position: relative;
        padding-left: ${toRem(32)};
        .icon-check.icon {
          position: absolute;
          left: ${toRem(8)};
          top: ${toRem(7)};
        }
      }

      &:hover {
        color: ${theme.color['cod-grey']};
        font-weight: ${theme.fonts['fontWeightRegular']};
      }
      &:focus {
        color: ${theme.color['cod-grey']};
        font-weight: ${theme.fonts['fontWeightRegular']};
        border: ${toRem(1)} solid ${theme.color['black']} !important;
      }
    }
      .reduced-font{
      font-size: 0.9rem !important;
      }
  }`}
`;
